export default function getAllCustomerSegments(customerSegments) {
    let AllCustomerSegmentNames = [];
    const allCustomerSegments = Object.keys(customerSegments);

    allCustomerSegments.forEach(element => {
        AllCustomerSegmentNames.push(...customerSegments[element]);
    });
    return AllCustomerSegmentNames;
}
